import type { SetupTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const setupHi: SetupTranslation = {
  models: {
    intro:
      'AI कुंजी से आपके AI एजेंट जवाब लिख पाते हैं। यह आपको OpenAI, Anthropic या Google जैसी AI कंपनी से मिलती है। इसे यहाँ चिपकाएँ, हम आपके लिए इसकी जाँच कर देंगे। कुंजियाँ एन्क्रिप्ट करके रखी जाती हैं और फिर कभी नहीं दिखतीं।',
    empty:
      'पहली AI कुंजी जोड़ें, ताकि आपके एजेंट असली AI से जवाब दें। इसके बिना वे सिर्फ़ उन कुंजियों का इस्तेमाल कर सकते हैं जो सर्वर के पास पहले से हैं (नीचे सूची में) और ऑफ़लाइन प्रैक्टिस मॉडल का, जो बने-बनाए जवाब देता है।',
    addDescription:
      'चुनें कि कुंजी किसने दी, उसे चिपकाएँ और एक मॉडल चुनें। हम उसे एन्क्रिप्ट करके सेव करते हैं और तुरंत जाँचते हैं।',
    model: 'मॉडल',
    modelHint: 'वह AI मॉडल जिससे कुंजी की जाँच होगी। सुझाया गया मॉडल अच्छी शुरुआत है।',
    recommended: 'सुझाया गया',
    customModel: 'कोई और मॉडल…',
    customLabel: 'मॉडल का नाम',
    customHint: 'मॉडल का नाम ठीक वैसे लिखें जैसे प्रोवाइडर लिखता है।',
    customServerHint: 'अपने सर्वर के किसी मॉडल का नाम ठीक वैसे लिखें जैसे सर्वर लिखता है।',
    tiers: { fast: 'तेज़, कम लागत', balanced: 'संतुलित', capable: 'सबसे सक्षम' },
    serverAddress: 'सर्वर का पता',
    serverAddressHint: 'आपके अपने OpenAI-संगत सर्वर का https:// पता, जैसे https://llm.example.com/v1।',
    labelHint:
      'आपके और आपकी टीम के लिए एक नाम, जैसे “OpenAI प्रोडक्शन”। खाली छोड़ने पर हम प्रोवाइडर का नाम इस्तेमाल करते हैं।',
    moreOptions: 'और विकल्प',
    testNote:
      'सेव करने के बाद हम प्रोवाइडर को कुछ शब्दों का एक छोटा-सा जाँच संदेश भेजते हैं, ताकि पता चले कि कुंजी चलती है। इसकी लागत एक सेंट के बहुत छोटे हिस्से जितनी है।',
    saveAndTest: 'सेव करें और जाँचें',
    errors: { model: 'कोई मॉडल चुनें, या उसका नाम लिखें।' },
    addedOn: '{{date}} को जोड़ा गया',
    columns: { lastTest: 'पिछली जाँच' },
    lastTest: { never: 'अभी जाँची नहीं गई', ok: 'चली' },
    test: 'कुंजी जाँचें',
    testLabel: '{{label}} की कुंजी जाँचें',
    testTitle: '{{label}} की कुंजी की जाँच',
    testDescription:
      'हम AI प्रोवाइडर को एक छोटा-सा संदेश भेजते हैं और दिखाते हैं कि क्या जवाब आया। आपके ग्राहकों की चैट में कुछ नहीं जुड़ता।',
    testing: 'कुंजी की जाँच हो रही है…',
    testingWith: '{{model}} से कुंजी की जाँच हो रही है…',
    testAgain: 'फिर जाँचें',
    testedWith: 'इस मॉडल से जाँचा गया',
    probe: {
      ok: { title: 'कुंजी चलती है', body: 'AI ने हमारे जाँच संदेश का जवाब दिया।' },
      wrong_key: {
        title: 'कुंजी स्वीकार नहीं हुई',
        body: 'देखें कि आपने पूरी कुंजी कॉपी की है और वह इसी प्रोवाइडर की है। आप उसे सूची से बदल सकते हैं।',
      },
      no_credit: {
        title: 'क्रेडिट खत्म हो गया',
        body: 'कुंजी असली है, पर खाते में क्रेडिट नहीं बचा। प्रोवाइडर के पास क्रेडिट जोड़ें और फिर जाँचें।',
      },
      model_not_found: {
        title: 'मॉडल नहीं मिला',
        body: 'प्रोवाइडर इस मॉडल का नाम नहीं जानता। सूची से कोई दूसरा मॉडल चुनें या वर्तनी देखें।',
      },
      network: {
        title: 'प्रोवाइडर तक पहुँच नहीं हो सकी',
        body: 'अगर आपने सर्वर का पता दिया है तो उसे जाँचें, फिर एक मिनट बाद दोबारा कोशिश करें।',
      },
      blocked: {
        title: 'यह सर्वर पता मान्य नहीं है',
        body: 'सार्वजनिक https:// पता इस्तेमाल करें, या अपने Hamnivo सर्वर को चलाने वाले से पूछें।',
      },
      rate_limited: {
        title: 'प्रोवाइडर धीमे चलने को कह रहा है',
        body: 'एक मिनट रुकें और फिर जाँचें।',
      },
      unavailable: {
        title: 'प्रोवाइडर को दिक्कत हो रही है',
        body: 'कुछ मिनट बाद फिर कोशिश करें।',
      },
      unknown: {
        title: 'जाँच नहीं चली',
        body: 'हमें कारण नहीं पता। फिर कोशिश करें, या प्रोवाइडर के पास कुंजी और मॉडल देखें।',
      },
    },
    replace: {
      action: 'कुंजी बदलें',
      label: '{{label}} की कुंजी बदलें',
      title: '{{label}} की कुंजी बदलें',
      description:
        'नई कुंजी चिपकाएँ। इस कनेक्शन का इस्तेमाल करने वाले एजेंट नई कुंजी से चलते रहते हैं और पुरानी चलना बंद कर देती है। पहले आपसे दोबारा साइन इन करने को कहा जा सकता है।',
      newKey: 'नई API कुंजी',
      newKeyHint:
        'मौजूदा कुंजी के आखिरी अक्षर {{hint}} हैं। नई कुंजी एन्क्रिप्ट करके रखी जाती है और फिर नहीं दिखती।',
      submit: 'बदलें और जाँचें',
      replaced: '{{label}} की कुंजी बदल दी गई।',
      done: 'कुंजी बदल गई। नई कुंजी के आखिरी अक्षर {{hint}} हैं।',
    },
    server: {
      title: 'इस सर्वर की कुंजियाँ',
      description:
        'आपका Hamnivo सर्वर चलाने वाला उसे अपनी AI कुंजियाँ दे सकता है। एजेंट यहाँ कनेक्शन बनाए बिना उन्हें इस्तेमाल कर सकते हैं। हम सिर्फ़ यह दिखाते हैं कि कुंजी लगी है या नहीं, कुंजी कभी नहीं दिखाते।',
      loading: 'सर्वर की सेटिंग लोड हो रही हैं',
      set: 'कुंजी लगी है',
      notSet: 'कोई कुंजी नहीं',
      jev: 'Jev',
      jevHint: 'सवालों को सही जगह भेजता है और जवाबों की दोबारा जाँच करता है। वैकल्पिक।',
      jevOn: 'सेट अप है',
      jevOff: 'सेट अप नहीं है',
      embeddings: 'जानकारी में खोज',
      embeddingsMock:
        'सादा शब्द-मिलान, आज़माने के लिए ठीक। मतलब के आधार पर खोज के लिए सर्वर पर OpenAI या Google की कुंजी चाहिए।',
      embeddingsReady: '{{provider}} से मतलब के आधार पर खोजता है।',
      embeddingsMissing: '{{provider}} इस्तेमाल करने पर सेट है, पर सर्वर के पास उसकी कुंजी नहीं है।',
      embeddingsOn: 'मतलब के आधार पर',
      embeddingsBasic: 'सादा',
      embeddingsNotReady: 'तैयार नहीं',
    },
  },
  home: {
    guided: 'गाइडेड सेटअप खोलें',
    steps: {
      brand: {
        title: 'अपना ब्रांड और वेबसाइट जोड़ें',
        description: 'ब्रांड का नाम दें और अपनी वेबसाइट को अनुमति दें, ताकि चैट वहाँ लोड हो सके।',
      },
      install: {
        title: 'चैट को अपनी वेबसाइट पर लगाएँ',
        description: 'कोड अपनी वेबसाइट पर लगाएँ और वहाँ कोई पेज खोलें। Studio इसे अपने-आप देख लेगा।',
      },
      engine: {
        title: 'चैट इंजन जोड़ें',
        description: 'हर ब्रांड के लिए इसे एक बार जोड़ें, ताकि चैट आपकी टीम तक पहुँचें।',
      },
      aikey: {
        title: 'AI कुंजी जोड़ें',
        description:
          'असली जवाब लिखने के लिए आपके AI एजेंट को OpenAI, Anthropic या Google जैसी AI कंपनी की कुंजी चाहिए।',
      },
      agent: {
        title: 'AI एजेंट प्रकाशित करें',
        description:
          'आपका असिस्टेंट ग्राहकों को तभी जवाब देता है जब आप उसे असली AI मॉडल के साथ प्रकाशित करें, ऑफ़लाइन प्रैक्टिस मॉडल के साथ नहीं।',
      },
      team: {
        title: 'साथी को बुलाएँ',
        description: 'उन लोगों को जोड़ें जो आपके साथ चैट का जवाब देंगे।',
      },
    },
  },
  leave: {
    title: 'बिना सेव किए छोड़ें?',
    description: 'आपके कुछ बदलाव सेव नहीं हैं। अभी छोड़ने पर वे खो जाएँगे।',
    keep: 'बदलाव जारी रखें',
    discard: 'बदलाव छोड़ दें',
  },
  appearance: {
    open: 'रूप और शब्द',
    openLabel: '{{name}} की चैट का रूप और शब्द बदलें',
    title: '{{name}} की चैट का रूप और शब्द',
    description:
      'रंग, लोगो और वे शब्द चुनें जो ग्राहक देखते हैं। फ़ील्ड के बगल की तस्वीर आपके लिखते ही बदलती है, और सेव करने तक ग्राहकों तक कुछ नहीं पहुँचता।',
    loading: 'चैट का रूप लोड हो रहा है',
    previewTitle: 'ग्राहक क्या देखेंगे',
    previewNote: 'चैट की एक तस्वीर। असली चैट आज़माने के लिए ब्रांड पर “टेस्ट चैट” इस्तेमाल करें।',
    previewLabel: 'चैट का पूर्वावलोकन',
    previewLanguage: 'भाषा',
    previewState: 'कब दिखाएँ',
    stateOnline: 'टीम ऑनलाइन है',
    stateAway: 'टीम उपलब्ध नहीं है',
    colour: {
      label: 'मुख्य रंग',
      hint: 'चैट की ऊपरी पट्टी, भेजें बटन और आपके ग्राहकों के संदेशों के लिए इस्तेमाल होता है। रंग का कोड, जैसे #D17B00।',
      pick: 'मुख्य रंग चुनें',
      format: '# से शुरू होने वाला रंग का कोड इस्तेमाल करें, जिसमें छह अक्षर या अंक हों, जैसे #D17B00।',
      text: 'इस रंग पर लिखा पढ़ना मुश्किल है।',
      faint: 'यह रंग सफ़ेद के बहुत करीब है, इसलिए वेब पेज पर उभरकर नहीं दिखता।',
      suggest: 'थोड़ा गहरा रंग, {{colour}}, पढ़ने में आसान है।',
      apply: '{{colour}} इस्तेमाल करें',
    },
    logo: {
      label: 'लोगो का वेब पता',
      hint: 'आपके लोगो की तस्वीर का https:// पता, जैसे https://example.com/logo.png। यह आपके ब्रांड के नाम के बगल में छोटा दिखता है।',
    },
    radius: {
      label: 'कोनों की गोलाई',
      value: '{{px}} px',
      hint: '0 का मतलब सीधे कोने। बड़ी संख्या यानी ज़्यादा गोल।',
    },
    greeting: {
      label: 'अभिवादन',
      hint: 'ग्राहक सबसे पहले यही पढ़ते हैं। Hamnivo का अभिवादन इस्तेमाल करने के लिए खाली छोड़ें। पहले अंग्रेज़ी लिखें: दूसरी भाषाएँ उसी पर लौटती हैं।',
    },
    offline: {
      label: 'कोई ऑनलाइन न हो तब का संदेश',
      hint: 'जब ग्राहक आपके कामकाज के घंटों के बाहर किसी व्यक्ति को माँगते हैं, तब वे यह पढ़ते हैं। जहाँ आपकी टीम के लौटने का समय आना चाहिए, वहाँ {when} लिखें। Hamnivo का संदेश इस्तेमाल करने के लिए खाली छोड़ें।',
    },
    csat: {
      label: 'ग्राहकों से चैट की रेटिंग माँगें',
      hint: 'चैट खत्म होने पर ग्राहक 1 से 5 सितारे दे सकते हैं और टिप्पणी छोड़ सकते हैं।',
    },
    privacy: {
      label: 'गोपनीयता नीति का वेब पता',
      hint: 'चैट के नीचे लिंक की तरह दिखता है, जैसे https://example.com/privacy।',
    },
    urlProblem: 'https:// से शुरू होने वाला वेब पता इस्तेमाल करें, जिसमें यूज़र नाम या पासवर्ड न हो।',
    englishFirst: 'पहले अंग्रेज़ी पाठ लिखें। दूसरी भाषाएँ उसी पर लौटती हैं।',
    reset: 'रीसेट करें',
    save: 'रूप सेव करें',
    saved: '{{name}} की चैट का रूप सेव हो गया।',
  },
  testChat: {
    open: 'टेस्ट चैट',
    openLabel: '{{name}} की चैट आज़माएँ',
    needsEngine: 'पहले इस ब्रांड के लिए चैट इंजन जोड़ें।',
    title: '{{name}} के लिए टेस्ट चैट',
    description:
      'यह आपकी असली चैट है, जो Studio के अंदर चल रही है। एक संदेश भेजकर देखें कि वह कैसी दिखती है और AI क्या जवाब देता है।',
    frameTitle: '{{name}} के लिए टेस्ट चैट',
    noteReal: 'यह असली चैट है: AI आपकी असली कुंजी और अपनी जानकारी से जवाब देता है।',
    noteReports: 'टेस्ट चैट आपकी रिपोर्ट और गिनती में शामिल नहीं होतीं।',
    noteUsage: 'वे किसी भी चैट की तरह आपके प्लान का इस्तेमाल करती हैं, और इनबॉक्स में दिख सकती हैं।',
  },
  brand: 'ब्रांड',
  hours: {
    nav: 'कामकाज के घंटे',
    title: 'कामकाज के घंटे',
    description:
      'ग्राहकों को बताएँ कि आपकी टीम कब जवाब देती है। इन घंटों के बाहर चैट बताती है कि कोई ऑनलाइन नहीं है और आप कब लौटेंगे। आपका AI असिस्टेंट हर समय जवाब देता है।',
    edit: 'कामकाज के घंटे बदलें',
    notSet: 'तय नहीं हैं। घंटे तय करने तक चैट कभी नहीं कहती कि कोई व्यक्ति उपलब्ध है।',
    closedAlways: 'हर दिन बंद',
    closedDays: 'बंद दिन: {{n}}',
    to: 'से',
    loading: 'कामकाज के घंटे लोड हो रहे हैं',
    noBrands: {
      title: 'अभी कोई ब्रांड नहीं',
      description: 'कामकाज के घंटे किसी ब्रांड के होते हैं। पहले एक ब्रांड जोड़ें।',
      action: 'ब्रांड पर जाएँ',
    },
    timezone: {
      label: 'समय क्षेत्र',
      hint: 'नीचे के घंटे इसी समय क्षेत्र में हैं, चाहे आपके ग्राहक कहीं भी हों।',
    },
    presets: {
      weekdays: 'सोमवार से शुक्रवार, 9:00 से 17:00',
      everyday: 'हर दिन, पूरे दिन',
      closed: 'हर दिन बंद',
    },
    week: {
      title: 'हफ़्ते के घंटे',
      hint: 'वे दिन चुनें जब आपकी टीम जवाब देती है और समय तय करें। बंद होने का समय 12:00 AM यानी उस दिन के अंत की आधी रात।',
      open: 'खुला',
      opens: 'खुलता है',
      closes: 'बंद होता है',
      add: 'एक और समय जोड़ें',
      remove: '{{day}} का यह समय हटाएँ',
    },
    holidays: {
      title: 'बंद दिन',
      description:
        'सार्वजनिक छुट्टियाँ और दूसरे पूरे दिन जब कोई जवाब नहीं देता। इन दिनों चैट बताती है कि कोई ऑनलाइन नहीं है।',
      date: 'दिन',
      add: 'दिन जोड़ें',
      remove: '{{date}} हटाएँ',
      none: 'कोई बंद दिन नहीं।',
    },
    problems: {
      time: '{{day}} के लिए खुलने और बंद होने का समय डालें।',
      order: '{{day}} को बंद होने का समय खुलने के बाद का होना चाहिए।',
      overlap: '{{day}} को समय आपस में टकराने नहीं चाहिए।',
      zone: 'सूची से कोई समय क्षेत्र चुनें।',
      date: 'बंद दिनों में से एक तारीख नहीं है।',
    },
    save: 'घंटे सेव करें',
    saved: '{{name}} के कामकाज के घंटे सेव हो गए।',
    reset: 'रीसेट करें',
    unsaved: 'आपके कुछ बदलाव सेव नहीं हैं।',
    noPermission: 'कामकाज के घंटे बदलवाने के लिए किसी ओनर या एडमिन से कहें।',
    remove: {
      action: 'घंटे हटाएँ',
      title: '{{name}} के घंटे हटाएँ?',
      body: 'इसके बाद चैट कभी नहीं कहती कि कोई व्यक्ति उपलब्ध है। आप कभी भी घंटे फिर से तय कर सकते हैं।',
      confirm: 'घंटे हटाएँ',
      done: '{{name}} के घंटे हटा दिए गए।',
    },
  },
  identity: {
    nav: 'ग्राहक साइन-इन',
    title: 'ग्राहक साइन-इन',
    description:
      'अपनी वेबसाइट को Hamnivo को बताने दें कि साइन-इन किया हुआ ग्राहक कौन है, ताकि वह हर डिवाइस पर अपनी चैट देख सके। इसे कोई डेवलपर सेट करता है; अगर आपके ग्राहक वेबसाइट पर साइन इन नहीं करते, तो आप इसे छोड़ सकते हैं।',
    guide: 'डेवलपर के लिए गाइड पढ़ें',
    loading: 'ग्राहक साइन-इन कुंजियाँ लोड हो रही हैं',
    noBrands: 'ग्राहक साइन-इन किसी ब्रांड का होता है। पहले एक ब्रांड जोड़ें।',
    noPermission: 'इन कुंजियों को संभालने के लिए किसी ओनर या एडमिन से कहें।',
    empty: {
      title: 'अभी कोई कुंजी नहीं',
      description:
        'आपकी वेबसाइट का सर्वर ग्राहक के बारे में एक छोटा नोट कुंजी से हस्ताक्षर करता है। कुंजी यहाँ बनाएँ और अपने डेवलपर को दें।',
    },
    columns: {
      name: 'कुंजी का नाम',
      type: 'प्रकार',
      status: 'स्थिति',
      added: 'जोड़ी गई',
      actions: 'कार्रवाइयाँ',
    },
    algs: {
      HS256: 'साझा गुप्त कुंजी (HS256)',
      ES256: 'सार्वजनिक कुंजी (ES256)',
      EdDSA: 'सार्वजनिक कुंजी (EdDSA)',
      RS256: 'सार्वजनिक कुंजी (RS256)',
    },
    status: { active: 'सक्रिय', retiring: 'जल्द बंद होगी', revoked: 'रद्द' },
    create: {
      action: 'कुंजी बनाएँ',
      title: 'ग्राहक साइन-इन कुंजी बनाएँ',
      description:
        'कुंजियाँ संभालने के लिए दो-चरणीय सत्यापन और हाल का साइन-इन ज़रूरी है। आपसे दोबारा साइन इन करने को कहा जा सकता है।',
      kind: 'किस तरह की कुंजी?',
      secret: 'साझा गुप्त कुंजी',
      secretHint: 'Hamnivo इसे आपके लिए बनाता है और एक बार दिखाता है। शुरू करने का सबसे आसान तरीका।',
      public: 'सार्वजनिक कुंजी',
      publicHint: 'निजी कुंजी आपके सर्वर पर रहती है और आप Hamnivo को सिर्फ़ सार्वजनिक हिस्सा देते हैं।',
      alg: 'हस्ताक्षर का प्रकार',
      jwk: {
        label: 'सार्वजनिक कुंजी (JWK)',
        hint: 'सार्वजनिक कुंजी को JSON के रूप में चिपकाएँ। निजी कुंजी कभी न चिपकाएँ: Hamnivo उसे नहीं मानता।',
        json: 'यह सही JSON नहीं है।',
        object: 'एक कुंजी को JSON ऑब्जेक्ट के रूप में चिपकाएँ।',
        private: 'यह निजी कुंजी जैसी लगती है। सिर्फ़ सार्वजनिक हिस्सा चिपकाएँ।',
      },
      name: 'कुंजी का नाम',
      nameHint: 'अक्षर, अंक, बिंदु, अंडरस्कोर और डैश, 64 तक। खाली छोड़ने पर Hamnivo एक चुन लेता है।',
      nameInvalid: 'सिर्फ़ अक्षर, अंक, बिंदु, अंडरस्कोर और डैश इस्तेमाल करें, 64 तक।',
      submitSecret: 'गुप्त कुंजी बनाएँ',
      submitPublic: 'कुंजी दर्ज करें',
    },
    rotate: {
      action: 'बदलें',
      label: 'कुंजी {{kid}} बदलें',
      title: 'कुंजी {{kid}} बदलें',
      description:
        'हम उसी तरह की नई कुंजी बनाते हैं और इसे “जल्द बंद होगी” चिह्नित करते हैं। ऐसी कुंजी अभी चलती रहती है, इसलिए आपका सर्वर बिना रुकावट नई कुंजी पर आ सकता है।',
      retireFailed:
        'नई कुंजी बन गई, पर {{kid}} को “जल्द बंद होगी” चिह्नित नहीं किया जा सका। उसकी पंक्ति में फिर “बदलें” आज़माएँ, या जब कोई उसका इस्तेमाल न करे तब उसे रद्द करें।',
    },
    revoke: {
      action: 'रद्द करें',
      label: 'कुंजी {{kid}} रद्द करें',
      title: 'कुंजी {{kid}} रद्द करें?',
      body: 'इस कुंजी से हस्ताक्षरित हर चीज़ अब से नकार दी जाएगी। यह तभी करें जब आपको पक्का पता हो कि आपका सर्वर अब इसका इस्तेमाल नहीं करता।',
      confirm: 'कुंजी रद्द करें',
      done: 'कुंजी {{kid}} रद्द कर दी गई।',
    },
    how: {
      title: 'बिना रुकावट कुंजी बदलना',
      description: 'इसे इसी क्रम में करें, ताकि ग्राहक कभी बाहर न हो जाएँ।',
      step1:
        'जो कुंजी चल रही है उस पर “बदलें” दबाएँ। नई कुंजी बनती है और पुरानी “जल्द बंद होगी” चिह्नित हो जाती है।',
      step2: 'नई कुंजी अपने डेवलपर को दें, जो आपकी वेबसाइट के सर्वर को उस पर ले आएगा।',
      step3: 'जब कोई भी पुरानी कुंजी का इस्तेमाल न करे, तो उस पर “रद्द करें” दबाएँ।',
    },
    created: 'कुंजी {{kid}} बन गई।',
    reveal: { title: 'आपकी नई गुप्त कुंजी', label: 'कुंजी {{kid}} की गुप्त कुंजी' },
  },
  teams: {
    nav: 'सपोर्ट टीमें',
    title: 'सपोर्ट टीमें',
    description: 'हर टीम में कौन है। चैट टीमों को सौंपी जाती हैं। यहाँ लोगों को जोड़ें या हटाएँ।',
    loading: 'टीमें लोड हो रही हैं',
    noPermission: 'टीमें बदलवाने के लिए किसी ओनर या एडमिन से कहें।',
    empty: {
      title: 'अभी कोई टीम नहीं',
      description: 'टीम उन लोगों का समूह है जो साथ मिलकर चैट का जवाब देते हैं, जैसे “सपोर्ट” या “सेल्स”।',
    },
    create: 'टीम बनाएँ',
    createTitle: 'टीम बनाएँ',
    createDescription: 'टीम को एक नाम दें। इसके बाद उसके लोगों को जोड़ें।',
    name: 'टीम का नाम',
    nameHint: 'जैसे “सपोर्ट” या “सेल्स”।',
    nameRequired: 'टीम को एक नाम दें।',
    created: 'टीम {{name}} बन गई।',
    archived: 'आर्काइव की गई',
    count: 'इस टीम में लोग: {{n}}',
    noMembers: 'इस टीम में अभी कोई नहीं है।',
    remove: '{{name}} को {{team}} से हटाएँ',
    removed: '{{name}} को {{team}} से हटा दिया गया।',
    addLabel: 'किसी को जोड़ें',
    choose: 'किसी को चुनें',
    everyone: 'सभी पहले से इस टीम में हैं',
    add: 'टीम में जोड़ें',
    added: '{{name}} को {{team}} में जोड़ा गया।',
    rules: 'चैट टीमों तक हर ब्रांड के नियमों से पहुँचती हैं।',
    rulesLink: 'नियम खोलें',
  },
  install: {
    platforms: {
      html: 'कोई भी वेबसाइट',
      wordpress: 'WordPress',
      woocommerce: 'WooCommerce',
      shopify: 'Shopify',
      whmcs: 'WHMCS',
      wix: 'Wix',
      squarespace: 'Squarespace',
      webflow: 'Webflow',
      'google-tag-manager': 'Google Tag Manager',
      react: 'React',
      vue: 'Vue',
      nextjs: 'Next.js',
    },
  },
  onboarding: {
    title: 'Hamnivo में आपका स्वागत है',
    description:
      'कुछ ही मिनटों में सेट अप करें। हर चरण छोड़ा जा सकता है और बाद में किया जा सकता है, और छोड़कर जाने पर भी आपका किया हुआ कुछ नहीं खोता।',
    later: 'बाद में पूरा करें',
    loading: 'आपका सेटअप लोड हो रहा है',
    railLabel: 'सेटअप के चरण',
    count: '{{total}} में से {{done}} चरण निपटे',
    stepOf: 'चरण {{n}} / {{total}}',
    back: 'वापस',
    skip: 'यह चरण छोड़ें',
    continue: 'आगे बढ़ें',
    needsBrand: 'इस चरण के लिए ब्रांड चाहिए। पहले एक जोड़ें।',
    toBrand: 'ब्रांड जोड़ें',
    state: { done: 'हो गया', skipped: 'छोड़ा गया', todo: 'अभी नहीं हुआ' },
    steps: {
      workspace: {
        name: 'वर्कस्पेस',
        title: 'आपका वर्कस्पेस',
        description: 'आपके कारोबार से जुड़ी हर चीज़ यहाँ रहती है।',
      },
      brand: {
        name: 'ब्रांड और वेबसाइट',
        title: 'आपका ब्रांड और वेबसाइट',
        description:
          'हर ब्रांड की अपनी चैट, अनुमति वाली वेबसाइट और AI असिस्टेंट होता है। हमें उसका नाम बताएँ और यह भी कि चैट कहाँ दिखेगी।',
      },
      engine: {
        name: 'चैट इंजन',
        title: 'चैट इंजन जोड़ें',
        description: 'चैट इंजन आपके ग्राहकों के संदेश आपकी टीम तक पहुँचाता है। यह खुद सेट अप हो जाता है।',
      },
      aikey: {
        name: 'AI कुंजी',
        title: 'AI कुंजी जोड़ें',
        description:
          'AI कुंजी से आपके AI एजेंट जवाब लिख पाते हैं। किसी AI कंपनी की कुंजी चिपकाएँ और हम जाँचेंगे कि वह चलती है।',
      },
      testchat: {
        name: 'टेस्ट चैट',
        title: 'चैट खुद आज़माएँ',
        description: 'किसी ग्राहक के देखने से पहले अपनी ही चैट में एक संदेश भेजें।',
      },
      install: {
        name: 'इंस्टॉल',
        title: 'चैट को अपनी वेबसाइट पर लगाएँ',
        description: 'चुनें कि आपकी वेबसाइट किससे बनी है, फिर कोड उसमें कॉपी करें।',
      },
      team: {
        name: 'टीम',
        title: 'अपनी टीम को बुलाएँ',
        description: 'उन लोगों को जोड़ें जो आपके साथ चैट का जवाब देंगे। यह बाद में भी किया जा सकता है।',
      },
    },
    workspace: {
      ready: 'आपका वर्कस्पेस {{name}} तैयार है।',
    },
    brand: {
      existing: 'सेट अप करने के लिए ब्रांड',
      existingHint: 'ये ब्रांड आपके वर्कस्पेस में पहले से हैं।',
      use: '{{name}} के साथ आगे बढ़ें',
      addAnother: 'दूसरा ब्रांड जोड़ें',
      website: 'आपकी वेबसाइट',
      websiteHint:
        'जहाँ चैट दिखेगी, जैसे noor.example। सिर्फ़ यही वेबसाइट चैट दिखा सकती है। आप इसे बाद में बदल सकते हैं।',
      create: 'ब्रांड बनाएँ',
      websiteInvalid:
        '{{value}} वेबसाइट का पता नहीं है। इसे ऐसे लिखें: noor.example या https://noor.example।',
      useExisting: 'मेरे पास जो ब्रांड है वही इस्तेमाल करें',
    },
    engine: {
      checking: 'आपका चैट इंजन जाँचा जा रहा है…',
      working: '{{name}} के लिए चैट इंजन सेट अप हो रहा है। इसमें थोड़ा समय लगता है।',
      ready: 'आपका चैट इंजन तैयार है।',
      retry: 'फिर कोशिश करें',
      disabled: 'कनेक्शन बंद है। किसी एडमिन से इसे चालू करने को कहें।',
      slow: 'इसमें सामान्य से ज़्यादा समय लग रहा है। आप यहाँ इंतज़ार कर सकते हैं, या यह चरण छोड़कर बाद में "ब्रांड और इंस्टॉल" में चैट इंजन जोड़ सकते हैं।',
      stopped: 'सेटअप रुक गया: {{error}} फिर कोशिश करें: यह वहीं से आगे बढ़ेगा जहाँ रुका था।',
      cancelled: 'साइन-इन बंद कर दिया गया, इसलिए सेटअप शुरू नहीं हुआ।',
    },
    aikey: {
      noPermission:
        'AI कुंजी सिर्फ़ वही जोड़ सकते हैं जो कनेक्शन संभालते हैं। किसी ओनर या एडमिन से कहें, या यह चरण छोड़ दें।',
      serverKey:
        'इस सर्वर के पास अपनी एक AI कुंजी पहले से है, इसलिए आपके एजेंट यहाँ कुंजी के बिना भी जवाब दे सकते हैं। अपने खाते का इस्तेमाल करने के लिए अपनी कुंजी जोड़ें।',
      have: 'आपके पास पहले से एक AI कुंजी है। जाँचकर देखें कि वह चलती है।',
    },
    testchat: {
      toEngine: 'चैट इंजन वाले चरण पर जाएँ',
      done: 'चल रही है, आगे बढ़ें',
    },
    install: {
      platform: 'आपकी वेबसाइट किससे बनी है?',
      platformHint: 'हम उसका गाइड लिंक करते हैं। पक्का न हो तो “कोई भी वेबसाइट” रहने दें।',
      guide: 'इंस्टॉलेशन गाइड खोलें: {{platform}}',
      where: 'यह कोड कहाँ जाता है?',
      whereBody:
        'इसे हर उस पेज पर चिपकाएँ जहाँ चैट दिखनी चाहिए, बंद होने वाले </body> टैग से ठीक पहले। वेबसाइट बिल्डर में कस्टम कोड या फ़ुटर में स्क्रिप्ट जोड़ने की जगह खोजें। ऊपर का गाइड ठीक जगह दिखाता है।',
      addWebsite: 'अपनी वेबसाइट जोड़ें',
      status: {
        waiting: 'आपकी वेबसाइट का इंतज़ार है',
        waitingBody:
          'कोड लगाएँ, वेबसाइट सेव या पब्लिश करें, फिर उसका कोई भी पेज खोलें। चैट वहाँ लोड होते ही यह अपने-आप बदल जाएगा।',
        check: 'अभी जाँचें',
        found: 'चैट आपकी वेबसाइट पर है',
        foundBody: 'अपनी वेबसाइट का कोई पेज खोलें और चैट से एक संदेश भेजें: वह आपके इनबॉक्स में दिखेगा।',
        lastSeen: 'आख़िरी बार {{time}} देखा गया',
        help: 'नहीं दिख रहा?',
        helpExact: 'पेज ऊपर दी गई किसी वेबसाइट पर ठीक उसी पते पर होना चाहिए, वही https और www के साथ।',
        helpCache: 'सेव करने के बाद पेज खोलें, या अपनी वेबसाइट का कैश साफ़ करें, ताकि नया कोड इस्तेमाल हो।',
        helpPolicy:
          'अगर आपकी वेबसाइट पर कंटेंट सिक्योरिटी पॉलिसी है, तो उसे Hamnivo की स्क्रिप्ट, फ़्रेम और कनेक्शन की अनुमति देनी होगी।',
        onWebsite: 'आपकी वेबसाइट पर',
        notSeen: 'अभी तक नहीं देखा गया',
      },
      done: 'मैंने कोड जोड़ दिया',
    },
    team: {
      none: 'यहाँ अभी आपके अलावा कोई नहीं है। आप लोगों को अभी या बाद में बुला सकते हैं।',
      some: 'आपके वर्कस्पेस में आपके अलावा लोग: {{people}}। भेजे गए न्योते: {{invited}}।',
      invite: 'साथी को बुलाएँ',
      finish: 'सेटअप पूरा करें',
      noPermission: 'लोगों को बुलाने के लिए किसी ओनर या एडमिन से कहें।',
    },
    finished: {
      title: 'सब तैयार है',
      titleOpen: 'सेटअप सेव हो गया',
      description: 'सब कुछ हो गया। आप इनमें से कुछ भी बाद में मेन्यू से बदल सकते हैं।',
      descriptionOpen:
        'बचे हुए चरण: {{n}}। आप इन्हें अभी या कभी भी कर सकते हैं; होम की सूची इनका हिसाब रखती है।',
      doSkipped: 'अभी करें',
      doTodo: 'अभी करें',
      go: 'होम पर जाएँ',
    },
  },
};
